import {isFeatureEnabled} from '@github-ui/feature-flags'
import type {JSFeatureFlag} from '@github-ui/feature-flags/client-feature-flags'
import {useCachePreheatQuery} from '@github-ui/relay-query-cache/hooks/use-cache-preheat-query'

import {IssueViewerViewGraphqlQuery} from '../components/IssueViewer'

type useCachePreheatIssueViewerProps = {
  owner: string
  repo: string
  number: number
  source: string
  featureFlag: JSFeatureFlag
}

export function useCachePreheatIssueViewer({
  owner,
  repo,
  number,
  source,
  featureFlag,
}: useCachePreheatIssueViewerProps) {
  const preHeatingEnabled = isFeatureEnabled(featureFlag)

  useCachePreheatQuery({
    query: IssueViewerViewGraphqlQuery,
    variables: {
      owner,
      repo,
      number,
      count: 15,
    },
    source,
    enabled: preHeatingEnabled,
  })
}
